module.exports = __webpack_public_path__ + "img/checkRegion.7328adff.svg";